// import FadeLoader from "react-spinners/FadeLoader";
import FadeLoader from "react-spinners/FadeLoader";
export default FadeLoader;